
export const WhatWeDo = () => {
    return (
        <section
            className="px-md-3 elementor-section elementor-top-section elementor-element elementor-element-6cec67a2 elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static"
            data-id="6cec67a2"
            data-element_type="section"
        >
            <div className="elementor-container elementor-column-gap-extended">
                <div
                    className="elementor-column elementor-col-66 elementor-top-column elementor-element elementor-element-43397fd1 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static"
                    data-id="43397fd1"
                    data-element_type="column"
                >
                    <div className=" elementor-widget-wrap elementor-element-populated">
                        <div
                            className="elementor-element elementor-element-5218af8a sc_fly_static elementor-widget elementor-widget-trx_sc_title"
                            data-id="5218af8a"
                            data-element_type="widget"
                            data-widget_type="trx_sc_title.default"
                        >
                            <div className="elementor-widget-container">
                                <div className="sc_title color_style_dark sc_title_default">
                                    <span className="sc_item_subtitle sc_title_subtitle sc_item_subtitle_above sc_item_title_style_default">
                                        What We Do
                                    </span>
                                    <h1 className="sc_item_title sc_title_title sc_item_title_style_default sc_item_title_tag">
                                        <span className="sc_item_title_text">
                                            Golden Agriculture; Building Trade. Feeding Futures.
                                        </span>
                                    </h1>
                                </div>
                            </div>
                        </div>
                        <div
                            className="elementor-element elementor-element-26dd9e84 sc_height_small sc_fly_static elementor-widget elementor-widget-spacer"
                            data-id="26dd9e84"
                            data-element_type="widget"
                            data-widget_type="spacer.default"
                        >
                            <div className="elementor-widget-container">
                                <div className="elementor-spacer">
                                    <div className="elementor-spacer-inner" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-51d682d7 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static"
                    data-id="51d682d7"
                    data-element_type="column"
                >
                    <div className="elementor-widget-wrap"></div>
                </div>
            </div>
        </section>
    )
}